import { useEffect, useState } from "react";
import api from "@/lib/api";
import { DataStampaField, oggiDmy } from "../components/DataStampaField";

export default function PrivacyEsterniPage() {
  const [items, setItems] = useState([]);
  const [modelli, setModelli] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [stampaFor, setStampaFor] = useState(null);
  const [anteprimaFor, setAnteprimaFor] = useState(null);
  const [err, setErr] = useState(null);
  const [search, setSearch] = useState("");

  const carica = async () => {
    setLoading(true); setErr(null);
    try {
      const [r, rm] = await Promise.all([
        api.get("/privacy/esterni"),
        api.get("/privacy/modelli", { params: { ambito: "esterno" } }),
      ]);
      setItems(r.data?.items || []);
      setModelli(rm.data?.items || []);
    } catch (e) { setErr(e.response?.data?.detail || "Errore caricamento"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const salva = async () => {
    try {
      const payload = { ...editing };
      if (editing._isNew) {
        delete payload._isNew;
        delete payload._orig;
        await api.post("/privacy/esterni", payload);
      } else {
        delete payload._orig;
        delete payload.codice;
        delete payload.created_at;
        delete payload.updated_at;
        await api.put(`/privacy/esterni/${encodeURIComponent(editing._orig)}`, payload);
      }
      setEditing(null);
      await carica();
    } catch (e) { setErr(e.response?.data?.detail || "Errore salvataggio"); }
  };

  const elimina = async (e) => {
    if (!window.confirm(`Eliminare l'esterno "${e.ragione_sociale}" (${e.codice})?`)) return;
    try { await api.delete(`/privacy/esterni/${encodeURIComponent(e.codice)}`); await carica(); }
    catch (er) { setErr(er.response?.data?.detail || "Errore"); }
  };

  const s = search.trim().toLowerCase();
  const filtered = !s ? items : items.filter(i =>
    (i.ragione_sociale + " " + (i.referente || "") + " " + (i.tipo_servizio || "") + " " + i.codice).toLowerCase().includes(s)
  );

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18, color: "#37474f" }}>🌐 Esterni / Fornitori</h2>
        <span style={{ fontSize: 11, color: "#666" }}>
          Anagrafica di soggetti esterni (commercialista, consulenti, ditte di assistenza, fornitori)
          autorizzabili sui Trattamenti come i docenti.
        </span>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Cerca..."
          data-testid="pe-search"
          style={{ marginLeft: "auto", padding: "5px 10px", border: "1px solid #ccc", fontSize: 12, minWidth: 240 }} />
        <button onClick={() => setEditing({ _isNew: true, ragione_sociale: "", attivo: true })}
          data-testid="pe-new-btn"
          style={{ background: "#2e7d32", color: "white", border: "none", padding: "6px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          + Nuovo esterno
        </button>
      </div>

      {err && <div style={{ padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, marginBottom: 10 }} data-testid="pe-error">{err}</div>}

      <div style={{ background: "white", border: "1px solid #ccc", overflow: "hidden" }}>
        <table className="sw-table sw-table-compact" style={{ width: "100%", fontSize: 12 }}>
          <thead className="thead-blue">
            <tr>
              <th style={{ width: 60 }}>CODICE</th>
              <th style={{ minWidth: 200 }}>RAGIONE SOCIALE</th>
              <th style={{ minWidth: 150 }}>SEDE</th>
              <th style={{ width: 130 }}>P.IVA</th>
              <th style={{ minWidth: 140 }}>REFERENTE</th>
              <th style={{ minWidth: 160 }}>EMAIL</th>
              <th style={{ width: 110 }}>TELEFONO</th>
              <th style={{ minWidth: 140 }}>TIPO SERVIZIO</th>
              <th style={{ width: 60, textAlign: "center" }}>ATTIVO</th>
              <th style={{ width: 100, textAlign: "center" }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={10} style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</td></tr>}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan={10} style={{ padding: 30, textAlign: "center", color: "#888" }}>
                {items.length === 0 ? "Nessun esterno presente. Clicca + Nuovo esterno per aggiungere il primo." : "Nessun esterno corrisponde al filtro."}
              </td></tr>
            )}
            {filtered.map((r, i) => (
              <tr key={r.codice} data-testid={`pe-row-${i}`}>
                <td style={{ fontFamily: "Consolas, monospace", fontWeight: 700, color: "#0d47a1" }}>{r.codice}</td>
                <td style={{ fontWeight: 600 }}>{r.ragione_sociale}</td>
                <td style={{ color: "#555" }}>{r.sede || "—"}</td>
                <td style={{ fontFamily: "Consolas, monospace", fontSize: 11 }}>{r.partita_iva || "—"}</td>
                <td>{r.referente || "—"}</td>
                <td style={{ fontSize: 11 }}>{r.email || "—"}</td>
                <td style={{ fontFamily: "Consolas, monospace", fontSize: 11 }}>{r.telefono || "—"}</td>
                <td style={{ fontSize: 11 }}>{r.tipo_servizio || "—"}</td>
                <td style={{ textAlign: "center" }}>
                  <span style={{ display: "inline-block", padding: "2px 8px", background: r.attivo ? "#c8e6c9" : "#ffcdd2", color: r.attivo ? "#1b5e20" : "#c62828", border: `1px solid ${r.attivo ? "#a5d6a7" : "#ef9a9a"}`, fontWeight: 700, fontSize: 10 }}>
                    {r.attivo ? "SÌ" : "NO"}
                  </span>
                </td>
                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                  <button onClick={() => setAnteprimaFor(r.codice)} data-testid={`pe-anteprima-${i}`}
                    title="Anteprima PDF della scheda"
                    style={{ padding: "3px 8px", background: "#6a1b9a", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>👁</button>
                  <button onClick={() => setStampaFor(r.codice)} data-testid={`pe-stampa-${i}`}
                    title="Genera scheda autorizzazione fornitore da modello"
                    style={{ padding: "3px 8px", background: "#c62828", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>🖨</button>
                  <button onClick={() => setEditing({ ...r, _orig: r.codice })} data-testid={`pe-edit-${i}`}
                    style={{ padding: "3px 8px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>✏</button>
                  <button onClick={() => elimina(r)} data-testid={`pe-delete-${i}`}
                    style={{ padding: "3px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && <EditModal editing={editing} setEditing={setEditing} onSave={salva} />}
      {stampaFor && <StampaEsternoModal codice={stampaFor} modelli={modelli} onClose={() => setStampaFor(null)} />}
      {anteprimaFor && <AnteprimaEsternoModal codice={anteprimaFor} modelli={modelli} onClose={() => setAnteprimaFor(null)} />}
    </div>
  );
}

// ============================================================
// STAMPA / ANTEPRIMA per ambito ESTERNO
// ============================================================
function StampaEsternoModal({ codice, modelli: initialModelli, onClose }) {
  const [modelli, setModelli] = useState(initialModelli || []);
  const [sel, setSel] = useState("");
  const [err, setErr] = useState("");
  const [dataStampa, setDataStampa] = useState(oggiDmy());

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/privacy/modelli", { params: { ambito: "esterno" } });
        if (alive) setModelli(r.data?.items || []);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  const scarica = async (formato) => {
    if (!sel) return;
    try {
      const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
        params: { esterno_codice: codice, formato, data_stampa: dataStampa },
        responseType: "blob",
      });
      const blob = new Blob([r.data], { type: r.headers["content-type"] });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const cd = r.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      a.download = m ? m[1] : `${codice}.${formato}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      onClose();
    } catch (e) {
      let msg = "Errore generazione documento";
      try { const t = await e.response?.data?.text?.(); if (t) msg = JSON.parse(t).detail || msg; } catch { /* ignore */ }
      setErr(msg);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pe-stampa-modal"
        style={{ background: "white", padding: 20, minWidth: 480, maxWidth: 600 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12, color: "#0d47a1" }}>🖨 Stampa scheda — Esterno {codice}</div>
        {err && <div style={{ background: "#ffebee", color: "#c62828", padding: 8, fontSize: 12, marginBottom: 10 }}>{err}</div>}
        <DataStampaField value={dataStampa} onChange={setDataStampa} testid="pe-stampa-data" />
        <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>MODELLO (ambito = esterno)</div>
        <select value={sel} onChange={e => setSel(e.target.value)} data-testid="pe-stampa-modello-select"
          style={{ width: "100%", padding: "6px 10px", border: "1px solid #ccc", fontSize: 12, marginBottom: 16 }}>
          <option value="">— scegli un modello —</option>
          {modelli.map(m => (
            <option key={m.codice} value={m.codice}>{m.codice} — {m.nome}{m.filename ? "" : " (no file)"}</option>
          ))}
        </select>
        {modelli.length === 0 && (
          <div style={{ background: "#fff3e0", padding: 8, fontSize: 11, color: "#e65100", marginBottom: 12 }}>
            ⚠ Non ci sono modelli con ambito 'esterno'. Carica un modello in Privacy → Catalogo Docx scegliendo ambito = Esterno / Fornitore.
          </div>
        )}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "8px 16px", background: "white", border: "1px solid #999", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={() => scarica("docx")} disabled={!sel} data-testid="pe-stampa-docx"
            style={{ padding: "8px 16px", background: sel ? "#1565c0" : "#bbb", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: sel ? "pointer" : "not-allowed" }}>📄 Scarica DOCX</button>
          <button onClick={() => scarica("pdf")} disabled={!sel} data-testid="pe-stampa-pdf"
            style={{ padding: "8px 16px", background: sel ? "#c62828" : "#bbb", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: sel ? "pointer" : "not-allowed" }}>📕 Scarica PDF</button>
        </div>
      </div>
    </div>
  );
}

function AnteprimaEsternoModal({ codice, modelli: initialModelli, onClose }) {
  const [modelli, setModelli] = useState(initialModelli || []);
  const [sel, setSel] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [err, setErr] = useState("");
  const [dataStampa, setDataStampa] = useState(oggiDmy());

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/privacy/modelli", { params: { ambito: "esterno" } });
        if (alive) setModelli(r.data?.items || []);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!sel) return;
    let alive = true;
    let createdUrl = "";
    (async () => {
      setLoading(true); setErr("");
      try {
        const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
          params: { esterno_codice: codice, formato: "pdf", data_stampa: dataStampa },
          responseType: "blob",
        });
        if (!alive) return;
        const blob = new Blob([r.data], { type: "application/pdf" });
        createdUrl = URL.createObjectURL(blob);
        setPdfUrl(createdUrl);
      } catch (e) {
        if (!alive) return;
        let msg = "Errore generazione anteprima";
        try { const t = await e.response?.data?.text?.(); if (t) msg = JSON.parse(t).detail || msg; } catch { /* ignore */ }
        setErr(msg); setPdfUrl("");
      } finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; if (createdUrl) URL.revokeObjectURL(createdUrl); };
  }, [sel, codice, dataStampa]);

  const scarica = async (formato) => {
    try {
      const r = await api.get(`/privacy/modelli/${encodeURIComponent(sel)}/genera`, {
        params: { esterno_codice: codice, formato, data_stampa: dataStampa }, responseType: "blob",
      });
      const blob = new Blob([r.data], { type: r.headers["content-type"] });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const cd = r.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      a.download = m ? m[1] : `${codice}.${formato}`;
      document.body.appendChild(a); a.click(); a.remove();
    } catch { setErr("Errore download"); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} data-testid="pe-anteprima-modal"
        style={{ background: "white", width: "90vw", maxWidth: 1200, height: "90vh", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "12px 16px", background: "#6a1b9a", color: "white", display: "flex", alignItems: "center", gap: 12, justifyContent: "space-between" }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>👁 Anteprima — Esterno {codice}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.9 }} title="Data di stampa (placeholder «Data.Stampa»)">📅 Data:</span>
            <input type="text" value={dataStampa} onChange={e => setDataStampa(e.target.value)}
              placeholder="gg/mm/aaaa"
              data-testid="pe-ant-data-stampa"
              title="Data di stampa (placeholder «Data.Stampa»)"
              style={{ padding: "4px 8px", border: "1px solid #ccc", fontSize: 12, width: 100, color: "#37474f", background: "white" }} />
            <select value={sel} onChange={e => setSel(e.target.value)} data-testid="pe-ant-modello-select"
              style={{ padding: "4px 8px", border: "1px solid #ccc", fontSize: 12, minWidth: 280, color: "#37474f", background: "white" }}>
              <option value="">— scegli un modello —</option>
              {modelli.map(m => (
                <option key={m.codice} value={m.codice}>{m.codice} — {m.nome}{m.filename ? "" : " (no file)"}</option>
              ))}
            </select>
            <button onClick={() => scarica("docx")} disabled={!sel || loading}
              style={{ padding: "5px 12px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: !sel || loading ? "not-allowed" : "pointer", opacity: !sel || loading ? 0.5 : 1 }}>📄 DOCX</button>
            <button onClick={() => scarica("pdf")} disabled={!sel || loading}
              style={{ padding: "5px 12px", background: "#c62828", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: !sel || loading ? "not-allowed" : "pointer", opacity: !sel || loading ? 0.5 : 1 }}>📕 PDF</button>
            <button onClick={onClose} style={{ background: "none", border: "none", color: "white", fontSize: 22, cursor: "pointer", padding: "0 4px" }}>✕</button>
          </div>
        </div>
        <div style={{ flex: 1, background: "#37474f", position: "relative" }}>
          {loading && <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: 13, fontWeight: 700 }}>⏳ Generazione anteprima...</div>}
          {!loading && err && <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ background: "#c62828", color: "white", padding: "12px 18px", fontSize: 12, fontWeight: 700, maxWidth: 600, textAlign: "center" }}>{err}</div></div>}
          {!loading && !err && pdfUrl && <iframe src={pdfUrl} title="Anteprima" style={{ width: "100%", height: "100%", border: "none", background: "white" }} />}
          {!loading && !err && !pdfUrl && !sel && (
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, color: "#cfd8dc", fontSize: 14 }}>
              <div style={{ fontSize: 48 }}>📄</div>
              <div style={{ fontWeight: 700 }}>Scegli un modello dall'alto per generare l'anteprima</div>
              {modelli.length === 0 && <div style={{ fontSize: 12, color: "#ff8a80" }}>Nessun modello con ambito 'esterno' disponibile.</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function EditModal({ editing, setEditing, onSave }) {
  const upd = (k, v) => setEditing({ ...editing, [k]: v });
  return (
    <div onClick={() => setEditing(null)}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pe-edit-modal"
        style={{ background: "white", padding: 20, width: 620, maxHeight: "90vh", overflow: "auto" }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, color: "#0d47a1" }}>
          {editing._isNew ? "Nuovo esterno / fornitore" : `Modifica ${editing.codice}`}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <Field label="Ragione sociale *" testid="pe-f-rs" full>
            <input type="text" value={editing.ragione_sociale || ""} onChange={e => upd("ragione_sociale", e.target.value)}
              data-testid="pe-i-rs"
              style={input} />
          </Field>
          <Field label="Sede" testid="pe-f-sede" full>
            <input type="text" value={editing.sede || ""} onChange={e => upd("sede", e.target.value)} style={input} />
          </Field>
          <Field label="Codice fiscale" testid="pe-f-cf">
            <input type="text" value={editing.codice_fiscale || ""} onChange={e => upd("codice_fiscale", e.target.value)} style={input} />
          </Field>
          <Field label="Partita IVA" testid="pe-f-piva">
            <input type="text" value={editing.partita_iva || ""} onChange={e => upd("partita_iva", e.target.value)} style={input} />
          </Field>
          <Field label="Referente" testid="pe-f-ref">
            <input type="text" value={editing.referente || ""} onChange={e => upd("referente", e.target.value)} style={input} />
          </Field>
          <Field label="Tipo servizio" testid="pe-f-srv">
            <input type="text" value={editing.tipo_servizio || ""} onChange={e => upd("tipo_servizio", e.target.value)} placeholder="es. Commercialista, Hosting, Manutenzione..." style={input} />
          </Field>
          <Field label="Compito assegnato" testid="pe-f-compito" full>
            <textarea value={editing.compito_assegnato || ""} onChange={e => upd("compito_assegnato", e.target.value)} rows={2}
              placeholder="Descrizione del compito assegnato all'esterno autorizzato (es. tenuta contabilità, manutenzione server...)"
              style={{ ...input, resize: "vertical" }} />
          </Field>
          <Field label="Email" testid="pe-f-mail">
            <input type="email" value={editing.email || ""} onChange={e => upd("email", e.target.value)} style={input} />
          </Field>
          <Field label="Telefono" testid="pe-f-tel">
            <input type="text" value={editing.telefono || ""} onChange={e => upd("telefono", e.target.value)} style={input} />
          </Field>
          <Field label="Data contratto" testid="pe-f-dc">
            <input type="text" value={editing.data_contratto || ""} onChange={e => upd("data_contratto", e.target.value)} placeholder="gg/mm/aaaa" style={input} />
          </Field>
          <Field label="Stato" testid="pe-f-att">
            <label style={{ display: "flex", alignItems: "center", gap: 6, padding: 6, fontSize: 12 }}>
              <input type="checkbox" checked={!!editing.attivo} onChange={e => upd("attivo", e.target.checked)} data-testid="pe-i-att" />
              Attivo (può essere autorizzato sui Trattamenti)
            </label>
          </Field>
          <Field label="Note" testid="pe-f-note" full>
            <textarea value={editing.note || ""} onChange={e => upd("note", e.target.value)} rows={3} style={{ ...input, resize: "vertical" }} />
          </Field>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
          <button onClick={() => setEditing(null)} data-testid="pe-cancel"
            style={{ padding: "8px 16px", background: "white", border: "1px solid #999", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={onSave} disabled={!editing.ragione_sociale} data-testid="pe-save"
            style={{ padding: "8px 16px", background: editing.ragione_sociale ? "#2e7d32" : "#bbb", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: editing.ragione_sociale ? "pointer" : "not-allowed" }}>Salva</button>
        </div>
      </div>
    </div>
  );
}

const input = { width: "100%", padding: "6px 10px", border: "1px solid #ccc", fontSize: 12, boxSizing: "border-box" };

function Field({ label, testid, children, full }) {
  return (
    <div style={{ gridColumn: full ? "1 / -1" : "auto" }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#555", marginBottom: 3 }} data-testid={testid}>{label}</div>
      {children}
    </div>
  );
}
